module.exports = __webpack_public_path__ + "img/shin3.b1b0967e.jpg";